import React from 'react';
import PropTypes from 'prop-types';

import PagePaths from './../PagePaths'

const PagePathsTab = ({pageId}) => {
  return (
    <PagePaths pageId={pageId} /> 
  );
};

PagePathsTab.propTypes = {
  pageId: PropTypes.number,
  show: PropTypes.bool
};

export default PagePathsTab;